import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../axios/axiosInstance';
import { BatchStatus, BatchType, MessageTransaction } from './types';
import { getStatusColor, getStatusText } from './render-utils';


export default function MessageTransactionsPage() {
  const [transactions, setTransactions] = useState<MessageTransaction[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {

    const loadTransactions = () => {
      setLoading(true)
      try {
        axiosInstance.get("/api/batch-jobs").then((response) => {
          // if(data.data == )
          console.log((response.data as any).data)
          setTransactions((response.data as any).data as MessageTransaction[])
        })
      } finally {
        setLoading(false)
      }
    }

    // const _loadTransactions = async () => {
    //   try {
    //     // const data = null
    //     // const response = await fetch('/api/batch');
    //     // const data = await response.json();
    //     let data = { success: false, data: { batchJobs: [] as any[] } }
    //     if (!data.success || !data.data?.batchJobs?.length) {
    //       // Import dummy data if no real transactions exist
    //       const dummyTransactions = [
    //         {
    //           id: '1',
    //           templateId: 'welcome_message',
    //           status: 'completed',
    //           progress: 100,
    //           totalRecipients: 50,
    //           successfulRecipients: ['1', '2', '3'],
    //           recipientsDetails: [],
    //           createdAt: '2023-06-01T10:00:00Z'
    //         },
    //         {
    //           id: '2',
    //           templateId: 'payment_reminder',
    //           status: 'processing',
    //           progress: 60,
    //           totalRecipients: 100,
    //           successfulRecipients: ['4', '5'],
    //           recipientsDetails: [
    //             { id: '6', status: 'failed' },
    //             { id: '7', status: 'failed' }
    //           ],
    //           createdAt: '2023-06-02T15:30:00Z'
    //         },
    //         {
    //           id: '3',
    //           templateId: 'event_invitation',
    //           status: 'failed',
    //           progress: 20,
    //           totalRecipients: 75,
    //           successfulRecipients: [],
    //           recipientsDetails: [
    //             { id: '8', status: 'failed' },
    //             { id: '9', status: 'failed' },
    //             { id: '10', status: 'failed' }
    //           ],
    //           createdAt: '2023-06-03T09:15:00Z'
    //         }
    //       ];
    //       data.success = true;
    //       data.data = { batchJobs: dummyTransactions };
    //     }

    //     if (data.success) {
    //       setTransactions(data.data.batchJobs.map((job: any) => ({
    //         id: job.id,
    //         templateName: job.templateId, // You might want to fetch template names separately
    //         status: job.status,
    //         progress: job.progress,
    //         totalRecipients: job.totalRecipients,
    //         successfulRecipients: job.successfulRecipients.length,
    //         failedRecipients: job.recipientsDetails.filter((r: any) => r.status === 'failed').length,
    //         channels: ['whatsapp'], // You might want to get this from the template
    //         createdAt: new Date(job.createdAt)
    //       })));
    //     }
    //   } catch (error) {
    //     console.error('Error loading transactions:', error);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    // loadTransactions();
    loadTransactions()
    const interval = setInterval(loadTransactions, 5000); // Refresh every 5 seconds

    return () => clearInterval(interval);
  }, []);


  const formatDate = (date: Date) => {
    return new Date(date).toLocaleString();
  };

  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          {/* <h1 className="text-3xl font-semibold mb-2 dark:text-white">Message Transactions</h1>
          <p className="text-neutral-600 dark:text-neutral-400">
            Track the status of all your sent messages
          </p> */}
          {/* <div className="mb-1"> */}

          <div className="px-1 pt-8 text-xl">Sent Messages</div>
          {/* </div> */}
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-neutral-800 dark:border-white"></div>
          </div>
        ) : (
          <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-neutral-100 dark:bg-neutral-700">
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                      Template
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                      Progress
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                      Recipients
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                      Channels
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                      Created At
                    </th>
                    <th className="px-6 py-3 text-center text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-neutral-200 dark:divide-neutral-700">
                  {transactions.map((transaction) => (
                    <tr
                      key={transaction.id}
                      className="hover:bg-neutral-50 dark:hover:bg-neutral-700 cursor-pointer"
                      onClick={() => navigate(`/message-transactions/${transaction.id}`)}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-neutral-900 dark:text-white">
                          {transaction.templateName}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`text-sm font-medium ${getStatusColor(transaction.status)}`}>
                          {
                            getStatusText(transaction.status)
                          }
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="w-24 bg-neutral-200 dark:bg-neutral-700 rounded-full h-2 mr-2">
                            <div
                              className="bg-blue-600 h-2 rounded-full"
                              style={{ width: `${transaction.progress}%` }}
                            ></div>
                          </div>
                          <span className="text-sm text-neutral-600 dark:text-neutral-400">
                            {Math.round(transaction.progress)}%
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-neutral-600 dark:text-neutral-400">
                          {transaction.successfulRecipients} / {transaction.totalRecipients}
                        </div>
                        {/* {transaction.failedRecipients > 0 && (
                          <div className="text-sm text-red-600 dark:text-red-400">
                            {transaction.failedRecipients} failed
                          </div>
                        )} */}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex space-x-2">
                          {/* {transaction.channels.map((channel) => (
                            <span
                              key={channel}
                              className="px-2 py-1 text-xs font-medium rounded-full bg-neutral-100 dark:bg-neutral-700 text-neutral-800 dark:text-neutral-200"
                            >
                              {channel.toUpperCase()}
                            </span>
                          ))} */}
                          <span className={`text-sm font-medium`}>
                            {transaction.batchType == BatchType.GROUP && transaction.message.channels?.whatsapp === true ? <span title="WhatsApp user" className="ml-1"><i className="fa-brands fa-whatsapp text-green-500"></i></span> : null}
                            {transaction.batchType ==  BatchType.GROUP && transaction.message.channels?.sms === true ? <span title="SMS user" className="ml-1"><i className="fa-solid fa-sms text-blue-500"></i></span> : null}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-600 dark:text-neutral-400">
                        {formatDate(transaction.createdAt)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/message-transactions/${transaction.id}`);
                          }}
                          className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
} 